import firebase from 'firebase/app';
import 'firebase/firestore';

var firebaseConfig = {
    apiKey: "AIzaSyCdWc0KERykAtawkapuKGhP9dqrzWCZPFY",
    authDomain: "svelte-todo-1-4675a.firebaseapp.com",
    databaseURL: "https://svelte-todo-1-4675a.firebaseio.com",
    projectId: "svelte-todo-1-4675a",
    storageBucket: "svelte-todo-1-4675a.appspot.com",
    messagingSenderId: "407466103388",
    appId: "1:407466103388:web:8385f9e386f7b6a77b0c99"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();

